
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from '@app/app.component';
import {
  AllEnterpriseModule,
  ClientSideRowModelModule,
  LicenseManager,
  ModuleRegistry,
  provideGlobalGridOptions,
  ServerSideRowModelModule
} from 'ag-grid-enterprise';
import { BoostrapAuthConfigHelper } from '../../shared/BoostrapAuthConfigHelper';
import { elzTheme } from '../../shared/elz-ag-grid-theme';
import { bootstrapPopoutWindow, isPopoutWindow } from './popout-bootstrap';
import { SHARED_PROVIDERS } from './shared-providers';

ModuleRegistry.registerModules([AllEnterpriseModule, ClientSideRowModelModule, ServerSideRowModelModule]);

provideGlobalGridOptions({
  theme: elzTheme
});

LicenseManager.setLicenseKey(BoostrapAuthConfigHelper.getAgGridLicenceKey());

function startApp() {
  if (isPopoutWindow()) {
    bootstrapPopoutWindow().catch(err => console.error(err));
    return;
  }
  bootstrapApplication(AppComponent, {
    providers: SHARED_PROVIDERS
  }).catch(err => console.error(err));
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => startApp());
} else {
  startApp();
}
